<template>
    <div class="content-wrapper">
        <div class="ibox-title">
            <h5>职工体检详情</h5>
        </div>
        <el-form class='ibox-content' style="padding-left: 0;">
            <div class="nav_cha">职工信息</div>
                <ul class='first_ul'>
                    <li>幼儿园：{{ResultByMecList.gardenName}}</li>
                    <li>姓名：{{ResultByMecList.teacherName}}</li>
                    <li>性别：{{ResultByMecList.teacherSex}}</li>
                    <li>生日：{{ResultByMecList.teacherBirthday}}</li>
                    <li>身份证号码：{{ResultByMecList.teacherIDCard}}</li>
                    <li>婚否：{{ResultByMecList.teacherMarry}}</li>
                    <li>岗位：{{ResultByMecList.teacherPosition}}</li>
                    <li>民族：{{ResultByMecList.national}}</li>
                    <li>手机号码：{{ResultByMecList.teacherTelPhone}}</li>
                    <div class="clear"></div>
                </ul>
            <div class="nav_cha">体检信息</div>
            <ul class="first_ul">
                <li>体检日期：{{ResultByMecList.checkDate}}</li>
                <li>体检单位：{{ResultByMecList.source}}</li>
                <li>主检医师：{{ResultByMecList.doctor}}</li>
                <div class="clear"></div>
            </ul>
            <div v-for='item in CategoryList' :key='item.id'>
                <div class="nav_cha">{{item.categoryName}}</div>
                <ul class="first_ul">
                    <template v-for='vl in DetailList'>
                        <li v-if='item.id  == vl.categoryId' class="phyWhather">{{vl.itemName}}：
                            <template v-for='el in staffMecItemList' v-if='vl.id==el.itemId'>
                                <span v-if='item.id==el.categoryId'>{{el.itemResult}} </span>
                            </template>
                        </li>
                    </template>
                    <div class="clear"></div>
                </ul>
                <div style="clear:both;"></div>
            </div>
            <div class="nav_cha">检查结果（医院评定）</div>
            <div>
                <el-form-item class="evaluate">
                    <el-input type='textarea' :rows='5' v-model="ResultByMecList.checkResult" :disabled=true></el-input>
                </el-form-item>
            </div>
            <div class="nav_cha">医生意见</div>
            <div>
                <el-form-item class="evaluate">
                    <el-input type='textarea' :rows='5' v-model="ResultByMecList.doctorSuggestion" :disabled=true></el-input>
                </el-form-item>
            </div>
        </el-form>
    </div>
</template>
<script>
    import api from '../../com/ajax' // ajax请求封装
    import config from '../../com/config' // url配置文件
    export default {
      data () {
        return {
          ResultByMecList: {},
          DetailList: [],
          CategoryList: [],
          staffMecItemList: [],
          doctorSuggestion: ''
        }
      },
      methods: {
        back () {
          this.$emit('close', false)
        }
      },
      created () {
        var that = this
        var param = {}
        param.id = that.$route.params.id
        api.post(config.host + 'staffMec/getCategoryList.do').then(function (response) {
          that.CategoryList = response.body
        })
        api.post(config.host + 'staffMec/getStaffMECResultByMecId.do', param).then(function (response) {
          that.ResultByMecList = response.body
          if (parseInt(that.ResultByMecList.teacherSex) === 1) {
            that.ResultByMecList.teacherSex = '男'
          } else {
            that.ResultByMecList.teacherSex = '女'
          }
          that.staffMecItemList = response.body.staffMecItemList
        })
        api.post(config.host + 'staffMec/getItemDetailList.do').then(function (response) {
          that.DetailList = response.body
        })
      },
      watch: {
        $route: {
          handler: function (val, oldVal) {
            var that = this
            var param = {}
            that.ResultByMecList = []
            param.id = that.$route.params.id
            api.post(config.host + 'staffMec/getCategoryList.do').then(function (response) {
              that.CategoryList = response.body
            })
            api.post(config.host + 'staffMec/getStaffMECResultByMecId.do', param).then(function (response) {
              that.ResultByMecList = response.body
              if (that.ResultByMecList.teacherSex === 1) {
                that.ResultByMecList.teacherSex = '男'
              } else {
                that.ResultByMecList.teacherSex = '女'
              }
              that.staffMecItemList = response.body.staffMecItemList
            })
            api.post(config.host + 'staffMec/getItemDetailList.do').then(function (response) {
              that.DetailList = response.body
            })
          },
          deep: true
        }
      }
    }
</script>
<style scoped>
    li{
        list-style: none;
    }
    .clear {
        clear: both;
    }
    .el-input {
        display: inline-block;
        width: 82%;
    }

    .nav_cha {
        height: 16px;
        line-height: 16px;
        margin: 12px;
        font-weight: bold;
        text-align: left;
    }

    .first_ul{
        padding-left: 25px;
    }

    .first_ul li {
        float: left;
        margin: 0px 25px 15px 0px;
        height: 30px;
        line-height: 30px;
        min-width: 220px;
        width: 360px;
    }

    .phyWhather {
        width: 20%;
        float: left;
        margin-left: 10px;
        margin-top: 35px;
        margin-bottom: 35px;
    }
    .inline {
        display: inline-block;
    }

    .evaluate {
        width: 80%;
        margin-left: 40px;
    }

    .evaluate .el-form-item__content{
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/physical/teacherPhyDet.vue